import React from 'react';
import { SkillChip } from 'components/Chip';

const SkillOption = ({ id, label, category, ...props }: any) => (
  <SkillChip key={id} id={id} label={label} category={category} {...props} />
);

export default SkillOption;
